export function selectedFromSearchParams(
  params: URLSearchParams, registry: { id: string }[],
): string {
  const p = params.get('p');
  if (p && registry.some((e) => e.id === p)) return p;
  return registry[0]?.id ?? '';
}

export function applySelection(params: URLSearchParams, id: string): URLSearchParams {
  params.set('p', id);
  return params;
}
